import React from "react";
import "../styles/fleet.css";
import { useNavigate } from "react-router-dom";

export default function Fleet() {
  const navigate = useNavigate();

  const vehicles = [
    {
      id: "wagonr",
      name: "Wagon R (Hatchback)",
      img: process.env.PUBLIC_URL + "/assets/wagonr.png",
      passengers: "4 Passengers",
      luggage: "2 Bags",
      ac: "Fully Air-Conditioned",
      rate: "Rs 80 per km",
      desc: "A compact, fuel-efficient choice ideal for city rides or short trips.",
    },
    {
      id: "prius",
      name: "Toyota Prius (Sedan)",
      img: process.env.PUBLIC_URL + "/assets/prius.png",
      passengers: "4 Passengers",
      luggage: "3 Bags",
      ac: "Fully Air-Conditioned",
      rate: "Rs 90 per km",
      desc: "Hybrid comfort—perfect for airport transfers or long-distance rides.",
    },
    {
      id: "vezel",
      name: "Honda Vezel (SUV)",
      img: process.env.PUBLIC_URL + "/assets/vezel.png",
      passengers: "4 Passengers",
      luggage: "4 Bags",
      ac: "Dual A/C",
      rate: "Rs 100 per km",
      desc: "Premium comfort and style with superior luggage space and smooth performance.",
    },
    {
      id: "hiace",
      name: "Passenger Van (Hiace)",
      img: process.env.PUBLIC_URL + "/assets/hiace.png",
      passengers: "10 Passengers",
      luggage: "6 Bags",
      ac: "Dual A/C",
      rate: "Rs 140 per km",
      desc: "Ideal for group trips, family outings, or office transport with spacious seating.",
    },
  ];

  // Pass vehicleId when navigating
  const handleBook = (vehicleId) => {
    navigate("/book", { state: { vehicleId } });
  };

  return (
    <section className="fleet-page">
      <div className="fleet-header">
        <h1>Our Fleet</h1>
        <p>
          Experience reliable comfort — from hatchbacks to vans, our vehicles are
          maintained for your safety and satisfaction.
        </p>
      </div>

      <div className="fleet-grid">
        {vehicles.map((v) => (
          <div key={v.id} className="fleet-card">
            <div className="fleet-img-wrapper">
              <img src={v.img} alt={v.name} className="fleet-img" />
            </div>

            <div className="fleet-info">
              <h2>{v.name}</h2>
              <p className="fleet-desc">{v.desc}</p>

              <ul className="fleet-specs">
                <li>👥 {v.passengers}</li>
                <li>🧳 {v.luggage}</li>
                <li>❄️ {v.ac}</li>
                <li>💰 {v.rate}</li>
              </ul>

              <button
                className="fleet-btn"
                onClick={() => handleBook(v.id)}
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
